import React, { useState } from "react";
import { Search, Building2, CheckCircle, Loader } from "lucide-react";
import { useNavigate } from "react-router";

// Моковые данные казахских компаний
const mockCompanies = {
  123456789012: {
    bin: "123456789012",
    name: 'ТОО "Astana Tech Solutions"',
    fullName:
      'Товарищество с ограниченной ответственностью "Astana Tech Solutions"',
    director: "Нурланов Ерлан Асланович",
    address: "г. Астана, район Есиль, проспект Мәңгілік Ел, д. 55/17, офис 402",
    phone: "+7 (7172) 55-44-33",
    email: "info@astanatech.kz",
    registrationDate: "15.03.2018",
    taxMode: "Общеустановленный режим",
    okpo: "87654321",
    kbe: "17",
    status: "Действующее",
  },
  987654321098: {
    bin: "987654321098",
    name: 'ТОО "Almaty Trading Company"',
    fullName:
      'Товарищество с ограниченной ответственностью "Almaty Trading Company"',
    director: "Сейтова Айгуль Маратовна",
    address: "г. Алматы, Алмалинский район, ул. Фурманова, д. 240, офис 12",
    phone: "+7 (727) 333-22-11",
    email: "contact@almatytrade.kz",
    registrationDate: "22.08.2015",
    taxMode: "Упрощенная декларация",
    okpo: "12345678",
    kbe: "16",
    status: "Действующее",
  },
  111222333444: {
    bin: "111222333444",
    name: 'ТОО "Shymkent Logistics"',
    fullName:
      'Товарищество с ограниченной ответственностью "Shymkent Logistics"',
    director: "Жумабаев Асет Кенжебекович",
    address: "г. Шымкент, Абайский район, ул. Байтурсынова, д. 88",
    phone: "+7 (7252) 44-55-66",
    email: "office@shymlogistics.kz",
    registrationDate: "10.11.2019",
    taxMode: "Общеустановленный режим",
    okpo: "55667788",
    kbe: "17",
    status: "Действующее",
  },
};

export const CompanyInfo = () => {
  const [bin, setBin] = useState("");
  const [companyData, setCompanyData] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  const navigate = useNavigate();

  const handleSearch = () => {
    if (bin.length !== 12) {
      setError("БИН должен содержать 12 цифр");
      return;
    }

    setError("");
    setIsSearching(true);
    setSaved(false);

    // Имитация поиска
    setTimeout(() => {
      const company = mockCompanies[bin];
      if (company) {
        setCompanyData(company);
        setError("");
      } else {
        setCompanyData(null);
        setError("Компания с указанным БИН не найдена");
      }
      setIsSearching(false);
    }, 1500);
  };

  const handleSave = () => {
    setSaved(true);
    navigate("/integration_setup");
  };

  const handleBinChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 12);
    setBin(value);
    setError("");
    setSaved(false);
  };

  const styles = {
    container: {
      minHeight: "100vh",
      background: "#ffffff",
      marginTop: "20px",
      borderRadius: "10px",
      padding: "40px 20px",
    },
    card: {
      maxWidth: "900px",
      margin: "0 auto",
      backgroundColor: "white",
      borderRadius: "16px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
      overflow: "hidden",
    },
    header: {
      background: "linear-gradient(135deg, #0077ffb7 0%, #0078FF 100%)",
      padding: "32px",
      color: "white",
    },
    headerTitle: {
      fontSize: "28px",
      fontWeight: "bold",
      marginBottom: "8px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    headerSubtitle: {
      fontSize: "16px",
      opacity: 0.9,
    },
    content: {
      padding: "32px",
    },
    searchSection: {
      marginBottom: "32px",
    },
    label: {
      display: "block",
      fontSize: "14px",
      fontWeight: "600",
      color: "#374151",
      marginBottom: "8px",
    },
    inputGroup: {
      display: "flex",
      gap: "12px",
    },
    input: {
      flex: 1,
      padding: "12px 16px",
      fontSize: "16px",
      border: "2px solid #e5e7eb",
      borderRadius: "8px",
      outline: "none",
      transition: "border-color 0.2s",
    },
    inputError: {
      flex: 1,
      padding: "12px 16px",
      fontSize: "16px",
      border: "2px solid #ef4444",
      borderRadius: "8px",
      outline: "none",
    },
    searchButton: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "12px 24px",
      backgroundColor: "#0078FF",
      color: "white",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "background-color 0.2s",
    },
    searchButtonDisabled: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "12px 24px",
      backgroundColor: "#9ca3af",
      color: "white",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "not-allowed",
    },
    hint: {
      fontSize: "13px",
      color: "#6b7280",
      marginTop: "6px",
    },
    error: {
      fontSize: "14px",
      color: "#ef4444",
      marginTop: "8px",
      padding: "8px 12px",
      backgroundColor: "#fee2e2",
      borderRadius: "6px",
    },
    loader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px",
      color: "#667eea",
    },
    companyCard: {
      border: "2px solid #e5e7eb",
      borderRadius: "12px",
      padding: "24px",
      marginBottom: "24px",
    },
    companyHeader: {
      borderBottom: "2px solid #f3f4f6",
      paddingBottom: "16px",
      marginBottom: "20px",
    },
    companyName: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#111827",
      marginBottom: "4px",
    },
    companyStatus: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "4px 12px",
      backgroundColor: "#d1fae5",
      color: "#065f46",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "600",
      marginTop: "8px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "20px",
    },
    field: {
      marginBottom: "4px",
    },
    fieldLabel: {
      fontSize: "13px",
      color: "#6b7280",
      marginBottom: "4px",
      fontWeight: "500",
    },
    fieldValue: {
      fontSize: "15px",
      color: "#111827",
      fontWeight: "500",
    },
    saveButton: {
      width: "100%",
      padding: "14px",
      backgroundColor: "#2ECC71",
      color: "white",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "background-color 0.2s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },
    savedButton: {
      width: "100%",
      padding: "14px",
      backgroundColor: "#059669",
      color: "white",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },
  };

  return (
    <div className={styles.wrapper}>
      {" "}
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.header}>
            <h1 style={styles.headerTitle}>
              <Building2 size={32} />
              Поиск компании по БИН
            </h1>
            <p style={styles.headerSubtitle}>
              Введите БИН для получения информации о казахской компании
            </p>
          </div>

          <div style={styles.content}>
            <div style={styles.searchSection}>
              <label style={styles.label}>
                БИН (Бизнес-идентификационный номер)
              </label>
              <div style={styles.inputGroup}>
                <input
                  type="text"
                  value={bin}
                  onChange={handleBinChange}
                  placeholder="Введите 12 цифр БИН"
                  style={
                    error && !isSearching ? styles.inputError : styles.input
                  }
                  onFocus={(e) => (e.target.style.borderColor = "#667eea")}
                  onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                  maxLength={12}
                />
                <button
                  onClick={handleSearch}
                  disabled={isSearching || bin.length !== 12}
                  style={
                    isSearching || bin.length !== 12
                      ? styles.searchButtonDisabled
                      : styles.searchButton
                  }
                  onMouseEnter={(e) => {
                    if (!isSearching && bin.length === 12) {
                      e.target.style.backgroundColor = "#5568d3";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isSearching && bin.length === 12) {
                      e.target.style.backgroundColor = "#667eea";
                    }
                  }}
                >
                  {isSearching ? (
                    <>
                      <Loader
                        size={20}
                        style={{ animation: "spin 1s linear infinite" }}
                      />
                      Поиск...
                    </>
                  ) : (
                    <>
                      <Search size={20} />
                      Найти
                    </>
                  )}
                </button>
              </div>
              <p style={styles.hint}>
                Примеры для теста: 123456789012, 987654321098, 111222333444
              </p>
              {error && <div style={styles.error}>{error}</div>}
            </div>

            {isSearching && (
              <div style={styles.loader}>
                <Loader
                  size={40}
                  style={{ animation: "spin 1s linear infinite" }}
                />
              </div>
            )}

            {companyData && !isSearching && (
              <>
                <div style={styles.companyCard}>
                  <div style={styles.companyHeader}>
                    <h2 style={styles.companyName}>{companyData.name}</h2>
                    <div style={styles.companyStatus}>
                      <CheckCircle size={16} />
                      {companyData.status}
                    </div>
                  </div>

                  <div style={styles.grid}>
                    <div style={styles.field}>
                      <div style={styles.fieldLabel}>БИН</div>
                      <div style={styles.fieldValue}>{companyData.bin}</div>
                    </div>

                    <div style={styles.field}>
                      <div style={styles.fieldLabel}>Дата регистрации</div>
                      <div style={styles.fieldValue}>
                        {companyData.registrationDate}
                      </div>
                    </div>

                    <div style={styles.field}>
                      <div style={styles.fieldLabel}>ОКПО</div>
                      <div style={styles.fieldValue}>{companyData.okpo}</div>
                    </div>

                    <div style={styles.field}>
                      <div style={styles.fieldLabel}>КБе</div>
                      <div style={styles.fieldValue}>{companyData.kbe}</div>
                    </div>

                    <div style={{ ...styles.field, gridColumn: "1 / -1" }}>
                      <div style={styles.fieldLabel}>Полное наименование</div>
                      <div style={styles.fieldValue}>
                        {companyData.fullName}
                      </div>
                    </div>

                    <div style={{ ...styles.field, gridColumn: "1 / -1" }}>
                      <div style={styles.fieldLabel}>Руководитель</div>
                      <div style={styles.fieldValue}>
                        {companyData.director}
                      </div>
                    </div>

                    <div style={{ ...styles.field, gridColumn: "1 / -1" }}>
                      <div style={styles.fieldLabel}>Юридический адрес</div>
                      <div style={styles.fieldValue}>{companyData.address}</div>
                    </div>

                    <div style={styles.field}>
                      <div style={styles.fieldLabel}>Телефон</div>
                      <div style={styles.fieldValue}>{companyData.phone}</div>
                    </div>

                    <div style={styles.field}>
                      <div style={styles.fieldLabel}>Email</div>
                      <div style={styles.fieldValue}>{companyData.email}</div>
                    </div>

                    <div style={{ ...styles.field, gridColumn: "1 / -1" }}>
                      <div style={styles.fieldLabel}>Режим налогообложения</div>
                      <div style={styles.fieldValue}>{companyData.taxMode}</div>
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleSave}
                  style={saved ? styles.savedButton : styles.saveButton}
                  onMouseEnter={(e) => {
                    if (!saved) {
                      e.target.style.backgroundColor = "#059669";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!saved) {
                      e.target.style.backgroundColor = "#10b981";
                    }
                  }}
                >
                  <CheckCircle size={20} />
                  {saved ? "Сохранено!" : "Сохранить данные"}
                </button>
              </>
            )}
          </div>
        </div>

        <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      </div>
    </div>
  );
};
